export default class RenameReportModalController {
  static $inject = ['$uibModalInstance'];

  name: string;
  description: string;

  constructor(private $uibModalInstance) {}

  saveAndClose() {
    this.$uibModalInstance.close({
      name: this.name,
      description: this.description,
    });
  }
}
